import produce from 'immer'
import {USER_AUTH, SWITCH_DIALOG} from 'actions'

const reducer = (state = {}, {type, response}) => {
  switch (type) {
  case USER_AUTH:
    return {...state, loggedIn: response}
  case SWITCH_DIALOG: {
    if (response?.dialog) {
      return produce(state, draftState => {
        draftState[(response?.dialog)] = !draftState[(response?.dialog)]
      })
    }
    break
  }
  default:
    return state
  }
}

export default reducer
